import { createAPIClient } from '../utils/apiHelpers';
import {
  ANALYTIKA_API_KEY,
  ANALYTIKA_EVENT_SOURCE,
  APP_NAME,
  APP_VERSION,
  BIFROST_MERCHANT_SERVICE_URL,
  BIFROST_LOCATIONS_URL,
  EVENT_COLLECTOR_URL,
  SAGW_API_BASE_URL
} from '../utils/constants';
import axios, { AxiosRequestConfig } from 'axios';

export { api } from '../utils/apiHelpers';

const config: AxiosRequestConfig = {
  baseURL: SAGW_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
};

export const sagwClient = createAPIClient(config);

const navigationsConfig: AxiosRequestConfig = {
  baseURL: `${SAGW_API_BASE_URL}/navigation`,
  headers: {
    'X-Client-Name': APP_NAME,
    'X-Client-Version': APP_VERSION,
    'Content-Type': 'application/json'
  }
};

const BIFROST_MERCHANT_SERVICE_CONFIG: AxiosRequestConfig = {
  baseURL: BIFROST_MERCHANT_SERVICE_URL,
  headers: {
    'Accept-Language': 'en-us',
    'Content-Type': 'application/json'
  }
};

const BIFROST_LOCATIONS_CONFIG: AxiosRequestConfig = {
  baseURL: BIFROST_LOCATIONS_URL,
  headers: {
    'X-Client-Name': APP_NAME,
    'X-Client-Version': APP_VERSION,
    'Accept-Language': 'en-us',
    'Content-Type': 'application/json'
  }
};

const EVENT_COLLECTOR_CONFIG: AxiosRequestConfig = {
  baseURL: EVENT_COLLECTOR_URL,
  headers: {
    'Accept-Language': 'en-us',
    'Content-Type': 'application/json',
    'event-source': ANALYTIKA_EVENT_SOURCE,
    'api-key': ANALYTIKA_API_KEY
  }
};

export const eventCollectorClient = axios.create(EVENT_COLLECTOR_CONFIG);

export const navigationsClient = createAPIClient(navigationsConfig);

export const bifrostLocationsClient = createAPIClient(BIFROST_LOCATIONS_CONFIG);

export const bifrostMerchantServiceClient = createAPIClient(BIFROST_MERCHANT_SERVICE_CONFIG);
